// extracted by mini-css-extract-plugin
module.exports = {"screenshots":"Gl0MDN3q","screenshot":"yyzyO78c","landscape":"mSFqFD9g","portrait":"gdduMjmZ"};